<div class="col-md-12">
    <nb-accordion class="recentTxList">
        <nb-accordion-item *ngFor="let tx of transactions">
            <nb-accordion-item-header>
                <div class="row d-flex w-100">
                    <div class="col-sm">
                        {{ tx.txHash }}
                    </div>
                    <div class="col-sm-2">
                        <a
                            style="text-decoration: none"
                            class="float-right"
                            href="https://testnet.cronoscan.com/tx/{{
                                tx.txHash
                            }}"
                            target="_blank"
                            >Cronos explorer</a
                        >
                    </div>
                </div>
            </nb-accordion-item-header>
            <nb-accordion-item-body>
                <div class="row w-100">
                    <div class="col-sm">
                        <h4>Amount</h4>
                    </div>
                    <div class="col-sm-4">
                        <h4 class="float-right">Status:</h4>
                    </div>
                </div>
                <div class="row w-100">
                    <div class="col-sm">
                        <h4 class="smallerWeightH4">
                            {{ tx.amount }}
                        </h4>
                    </div>
                    <div class="col-sm-4">
                        <h4 class="smallerWeightH4 float-right">
                            {{ tx.statusOfTx }}
                        </h4>
                    </div>
                </div>
            </nb-accordion-item-body>
        </nb-accordion-item>
    </nb-accordion>
</div>
